import { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";
import { useNavigate } from "react-router-dom";

export default function ResetPassword() {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      if (!data.session) {
        setError("❌ Reset link is invalid or expired.");
      }
    });
  }, []);

  const handleUpdatePassword = async (e) => {
    e.preventDefault();
    setMsg("");
    setError("");

    if (!password || password.length < 6) {
      return setError("Password must be at least 6 characters.");
    }
    if (password !== confirm) {
      return setError("Passwords do not match.");
    }

    setLoading(true);

    try {
      // ✅ Update password
      const { error } = await supabase.auth.updateUser({
        password,
      });

      if (error) throw error;

      setMsg("✅ Password updated successfully! Redirecting to login...");

      // ✅ IMPORTANT FIX: Logout recovery session immediately
      await supabase.auth.signOut();

      // ✅ Clear local session storage to avoid auto dashboard redirect
      localStorage.removeItem("token");
      localStorage.removeItem("auth_uid");
      localStorage.removeItem("userId");
      localStorage.removeItem("userEmail");

      setTimeout(() => {
        navigate("/login", { replace: true });
      }, 2000);

    } catch (err) {
      setError(err.message || "Failed to reset password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0F0A24] text-white">
      <form
        onSubmit={handleUpdatePassword}
        className="bg-[#11111f] border border-[#EB6AB5]/30 p-10 rounded-3xl w-full max-w-md space-y-5"
      >
        <h2 className="text-2xl font-bold text-pink-400 text-center">
          🔄 Reset Password
        </h2>

        <input
          type="password"
          placeholder="New Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full p-3 rounded bg-[#11111f] border border-[#EB6AB5]/30"
        />

        <input
          type="password"
          placeholder="Confirm Password"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          className="w-full p-3 rounded bg-[#11111f] border border-[#EB6AB5]/30"
        />

        {msg && <p className="text-green-400 text-sm">{msg}</p>}
        {error && <p className="text-red-400 text-sm">{error}</p>}

        <button
          type="submit"
          disabled={loading}
          className="w-full py-3 bg-[#EB6AB5] text-black rounded-full font-semibold"
        >
          {loading ? "Updating..." : "Update Password"}
        </button>
      </form>
    </div>
  );
}
